<template>
    <div>
        <div id="support-form" v-once></div>
    </div>
</template>
<script>
export default {
    mounted() {
        const script = document.createElement("script");
        script.src = "https://js.hsforms.net/forms/v2.js";
        document.body.appendChild(script);
        script.addEventListener("load", () => {
            if (window.hbspt) {
                window.hbspt.forms.create({
                    region: "na1",
                    portalId: "22692776",
                    formId: "5108020e-e3e0-47a0-ae89-37caf784c1f3",
                    target: "#support-form",
                });
            }
        });
    },
};
</script>
